import React, { useState, useEffect } from 'react';
import { X } from 'react-feather';
import { useHistory } from 'react-router-dom';
import { useInternationalization } from '../features/i18n';
import { Button } from './buttons';
import { Checkbox } from './dashboard-form';
import { PopupCore } from './popup';
import dayjs from 'dayjs'
import { useDispatch } from 'react-redux';
import { changeLanguage } from '../features/system/slice';

const image = {
  en: "/images/under_development_en.jpg",
  id: "/images/under_development_id.jpg",
}

const KEY = 'khub_under_development_popup'

const UnderDevelopmentPopup = () => {
  const dispatch = useDispatch()
  const [isAgreed, setIsAgreed] = useState(false)
  const [show, setShow] = useState(true)
  const history = useHistory()
  const { translate, language } = useInternationalization()

  useEffect(() => {
    if(localStorage.getItem(KEY)){
      const date1 = dayjs(localStorage.getItem(KEY))
      const date2 = dayjs()

      if(date2.diff(date1, 'day') >= 3){
        localStorage.removeItem(KEY)
      } else {
        setShow(false)
      }
    }
  }, [])

  const handleClose = () => {
    setShow(false)

    if(isAgreed){
      localStorage.setItem(KEY, dayjs().format())
    }
  }

  const handleClick = () => {
    handleClose()
    history.push('/about')
  }

  const handleCheckbox = e => {
    if(e.target && e.target !== null){
      setIsAgreed(e.target.checked)
    }
  }

  return <>
    {
      show &&
      <PopupCore onClose={handleClose} customPadding="pt-0" customWidth="w-full md:w-6/12 lg:w-4/12">
        <div className="flex items-center justify-between mb-8" onClick={e => e.stopPropagation()}>
          <div className="flex items-center">
            <div
              style={{backgroundImage: `url('/images/flags/khub_australia.svg')`, height: '15px', width: '20px', backgroundSize: '100%', backgroundColor: '#f8f8f8'}}
              className="bg-no-repeat bg-center shadow-md cursor-pointer"
              onClick={(e) => {e.stopPropagation(); dispatch(changeLanguage('en'))}}
            />
            <div
              style={{backgroundImage: `url('/images/flags/khub_indonesia.svg')`, height: '15px', width: '20px', backgroundSize: '100%', backgroundColor: '#f8f8f8'}}
              className="bg-no-repeat bg-center ml-4 shadow-md cursor-pointer"
              onClick={(e) => {e.stopPropagation(); dispatch(changeLanguage('id'))}}
            />
          </div>
          <X className="ml-4 cursor-pointer" onClick={handleClose}/>
        </div>
        <div>
          <img src={image[language.name]} alt="KHUB - Under Development" className="mb-8"/>
          <p className="mb-4">
            {translate('GENERAL', 'under_development_text')}
          </p>

          <div className="flex lg:block mb-8 lg:mb-4">
            <Checkbox
              label={translate('GENERAL', 'dont_show_again')}
              onChange={e => {e.persist(); handleCheckbox(e)}}
              checked={isAgreed}
              style={{width: '15px', height: '15px'}}
              width="15"
              height="15"
              id="dont_show_again"
            />
          </div>

          <p className="mb-8 font-bold">
            {translate('GENERAL', 'under_development_text_1')}
          </p>

          <div className="text-center">
            <Button
              className="inline-block uppercase text-lg"
              onClick={handleClick}
              customWidth="w-full lg:w-auto"
            >
              {translate('GENERAL', 'click_here')}
            </Button>
          </div>
        </div>
      </PopupCore>
    }
  </>
}

export default UnderDevelopmentPopup
